import React, { Component } from 'react';
import { Link } from 'react-router-dom';


import { withAuthorization } from '../Session';
import DagViz from './DagViz';

import * as ROUTES from '../../constants/routes';


class ViewDag extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      dag: null,
    };
    this.fetchData = this.fetchData.bind(this);
  }

  fetchData = () => {
    const flowId = this.props.match.params.flowId;
    const dagId = this.props.match.params.dagId;
    return this.props.firebase.dag(flowId, dagId).onSnapshot(
      snapshot => {
        this.setState({
          dag: snapshot.data(),
          loading: false,
        });
      }
    );
  }

  componentDidMount() {
    this.setState({ loading: true });
    this.unsubscribe =  this.fetchData();
  }


  render() {
    const { dag, loading } = this.state;
    const flowId = this.props.match.params.flowId;
    const dagId = this.props.match.params.dagId;

    const header = <div>
      <h2>
        <Link to={ROUTES.HOME}
            style={{textDecoration: 'none'}}>
          flows
        </Link>
        /
        <Link to={`/flow/${flowId}`}
            style={{textDecoration: 'none'}}>
          {flowId}
        </Link>
        /
        <span style={{color: '#FF5959'}}>
          {dagId}
        </span>
      </h2>
      <p>Information about the dag <b>{dagId}</b> is shown here.</p>
    </div>

    if ( loading ) {
      return(
        <div>
          {header}
          Loading..
        </div>
      )
    }

    if ( !loading && !dag ) {
      return(
        <div>
          {header}
          No dags found.
        </div>
      )
    }

    if ( !loading && dag ) {
      return (
        <div>
          {header}
          <DagViz flowId={flowId} dagId={dagId} />
        </div>
      );
    }
  }
}


const condition = authUser => !!authUser;

export default withAuthorization(condition)(ViewDag);
